import { switchMap, take } from 'rxjs';
import { fromFetch } from 'rxjs/fetch';
import { dataAccessEnvironment } from '../../models/data-access-environment';
import { PagedCollectionParams } from '../../models/paged-collection-params';
import { requiredHeaders } from '../../models/required-headers';
import { selectData } from '../../utils/select-data';
import { postJwt } from '../authws/post-jwt';
import { routingProfileServiceEnvironment } from './routing-profile-service-environment';
import { routingProfilePagedCollectionSchema } from './schemas/routing-profile-paged-collection.schema';

export function getRoutingProfiles(params?: PagedCollectionParams) {
  return postJwt({ authenticationToken: dataAccessEnvironment.authToken }).pipe(
    take(1),
    switchMap((jwt) => {
      dataAccessEnvironment.jwt = jwt.access_token;
      const requestUrl = `${
        routingProfileServiceEnvironment.routingProfilesUrl
      }?${params ? params.urlParams : ''}`;
      return fromFetch(
        new Request(requestUrl, {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            Authorization: `bearer ${jwt.access_token}`,
          },
        })
      ).pipe(selectData(routingProfilePagedCollectionSchema));
    })
  );
}
